export default function snakeCaseToCamelCase(str) {
  return str.replace(/(_\w)/g, (match) => match[1].toUpperCase())
}
